export const METHOD_RESET_REASONS = {
  CONFIGURATION_INCOMPATIBLE: 'configuration_incompatible',
};
